import React from 'react';
import { useHistory } from 'react-router-dom';
import Accordion from '../../common/Accordion';
import css from './FAQ.css';
import questions from './questions';
import { Button } from '../../../../components';
import config from '../../../../config';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { parse } from '../../../../util/urlHelpers';

const { userTypeHorseowner } = config;

export default ({ startIndex = 0, endIndex = 999 }) => {
    const history = useHistory();
    const { role } = parse(history.location.search);

    return (
        <section className={css.root}>
            <header className={css.header}>
                <h2 className={css.heading}>Häufige Fragen</h2>
            </header>

            <main className={css.faqHolder}>
                <Accordion
                    avoidTags
                    itemClassName={css.accordeonItem}
                    questions={questions.slice(startIndex, endIndex)}
                />
            </main>

            <p>
                Du hast weitere Fragen? <a href="/kontakt">Melde dich bei uns</a> und wir gehen
                persönlich auf dein Anliegen ein.
            </p>
            <footer className={css.footer}>
                <Button
                    className={css.subLinkPrimary}
                    onClick={() =>
                        history.push(
                            createResourceLocatorString(
                                role === userTypeHorseowner ? 'SignupRider' : 'SignupHorseowner',
                                routeConfiguration()
                            )
                        )
                    }
                >
                    Kostenlos registrieren
                </Button>
            </footer>
        </section>
    );
};
